import { Lightbulb, Layers, Compass, Rocket } from 'lucide-react';
import { PROCESS } from '@/constants/testIds';

const steps = [
  {
    testId: PROCESS.step1,
    icon: Lightbulb,
    title: 'Create Design',
    description: 'Begin by creating a detailed design that outlines the project scope, objectives, and deliverables. This stage sets the foundation for the entire project.',
    number: '01',
  },
  {
    testId: PROCESS.step2,
    icon: Layers,
    title: 'Develop Prototype',
    description: 'Develop a prototype that allows stakeholders to visualize functionality & provide feedback before full-scale development begins.',
    number: '02',
  },
  {
    testId: PROCESS.step3,
    icon: Compass,
    title: 'Finalize Plans',
    description: 'Finalize plans by detailing the project schedule, resource allocation, budget, & logistical aspects crucial for successful execution.',
    number: '03',
  },
  {
    testId: PROCESS.step4,
    icon: Rocket,
    title: 'Launch Project',
    description: 'Execute according to the established timeline and objectives while keeping communication channels open for feedback and adjustments.',
    number: '04',
  },
];

const WorkProcess = () => {
  return (
    <section data-testid={PROCESS.section} className="py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-xs font-mono uppercase tracking-[0.3em] text-amber mb-4">Our Process</p>
          <h2 className="font-heading text-3xl lg:text-4xl font-bold text-white tracking-tight">
            Working with Few Process — It's Simple
          </h2>
          <p className="text-slate-400 mt-4 max-w-xl mx-auto text-sm leading-relaxed">
            Distinctively grow go-forward manufactured products and enthusiastically disseminate outsourcing customer service.
          </p>
        </div>

        {/* Bento-style grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {steps.map((step) => {
            const Icon = step.icon;
            return (
              <div
                key={step.number}
                data-testid={step.testId}
                className="bg-surface border border-white/10 rounded-sm p-8 card-hover group relative overflow-hidden"
              >
                {/* Large number watermark */}
                <span className="absolute top-4 right-6 font-heading text-6xl font-bold text-white/5 select-none">
                  {step.number}
                </span>

                <div className="relative z-10">
                  <div className="w-12 h-12 bg-amber/10 rounded-sm flex items-center justify-center mb-5 group-hover:bg-amber/20 transition-colors">
                    <Icon className="w-6 h-6 text-amber" />
                  </div>
                  <h3 className="font-heading text-lg font-bold text-white mb-3">{step.title}</h3>
                  <p className="text-sm text-slate-400 leading-relaxed">{step.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WorkProcess;
